import { Badge, Box, Group, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const IccidCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Stack gap={0}>
                {rowData.simcard ? (
                    <>
                        <NavLink
                            to={`/resources/simcards/${rowData.simcard.id}`}
                            target='_blank'>
                            <Text>
                                {rowData.simcard.iccid ||
                                    '89015809000304167245'}
                            </Text>
                        </NavLink>
                        <Text>{rowData.simcard.imei || '356422103189102'}</Text>
                    </>
                ) : (
                    <Text>No simcard</Text>
                )}
            </Stack>
        </Box>
    );
};

const IccidColumn = () => ({
    accessorKey: 'iccid',
    header: 'Iccid / Imei',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <IccidCell cell={cell} />,
});
export default IccidColumn;
